export default "__VITE_PUBLIC_ASSET__b0679bfc__"